import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Logo, UserMockImage } from "../../core/path/images";
import { useUser } from "../../core/context/user";
import Modal from "../../components/profile-modal";
import { RoutesAndTheirNames } from "../../utils/constants";
import { LogoutAndRemoveState } from "../../core/axios/auth";

// Jira-achtige topbalk: logo links, paginanaam, profielmenu rechts.
// Functioneel identiek aan de oude header (mobiel menu, profiel, uitloggen).
const EXTRA_PAGE_NAMES = [
  { path: "/borden", name: "Borden" },
  { path: "/btw-batterij-instellingen", name: "Statussen" },
  { path: "/btw-batterij", name: "BTW Batterij" },
  { path: "/partner-facturen", name: "Partner-facturen" },
  { path: "/btw-email-templates", name: "Mail-templates" },
  { path: "/btw-labels", name: "Labels" },
  { path: "/btw-teruggaves", name: "BTW Teruggaves" },
  { path: "/partner-subsidie-aanvragen", name: "Subsidie-aanvragen" },
];

const Header = () => {
  const { userData, updateUser } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const sidebarOverlay = () => {
    document.querySelector(".main-wrapper").classList.toggle("slide-nav");
    document.querySelector(".sidebar-overlay").classList.toggle("opened");
    document.querySelector("html").classList.toggle("menu-opened");
  };

  const typeNames = { btw: "BTW Batterij", eia: "EIA", eiaZon: "EIA Zon", isde: "ISDE" };
  const typeParam = location.pathname.endsWith("/borden/alle") ? new URLSearchParams(location.search).get("type") : null;
  const currentPage =
    (typeParam && typeNames[typeParam]) ||
    [...EXTRA_PAGE_NAMES, ...RoutesAndTheirNames].find((r) => location.pathname.includes(r.path))?.name || "";

  const logout = async () => {
    await LogoutAndRemoveState();
    navigate("/signIn");
    updateUser(null);
  };

  const isAdmin = userData?.role === "admin";
  const home = isAdmin ? "/panel/admin/dashboard" : "/panel/customer/dashboard";

  return (
    <div className="header">
      <Link className="mobile_btn" to="#" onClick={sidebarOverlay} aria-label="Menu">
        <FeatherIcon icon="menu" size={20} />
      </Link>

      <div className="header-left">
        <Link to={home} className="logo" aria-label="Naar dashboard">
          <img src={Logo} alt="Subsidie2gether" />
        </Link>
      </div>

      {currentPage ? (
        <div className="header-title">
          <span className="text-ink-subtlest">/</span>
          <span className="ml-2 text-ink">{currentPage}</span>
        </div>
      ) : null}

      <div className="header-right">
        <details className="dropdown dropdown-end">
          <summary className="header-icon-btn list-none" style={{ width: "auto", padding: "0 4px" }} aria-label="Profielmenu">
            <img src={userData?.profielFoto || UserMockImage} alt="" className="header-avatar" />
          </summary>
          <div className="dropdown-content z-[1200] mt-2 w-64 p-2">
            <div className="flex items-center gap-3 px-2 py-2">
              <img src={userData?.profielFoto || UserMockImage} alt="" className="h-9 w-9 rounded-full object-cover" />
              <div className="min-w-0">
                <div className="truncate text-sm font-medium text-ink">{userData?.naam || ""}</div>
                <div className="truncate text-xs text-ink-subtlest">{userData?.email || (isAdmin ? "Admin" : "Klant")}</div>
              </div>
            </div>
            <div className="my-1 border-t border-line" />
            <button
              type="button"
              onClick={(e) => {
                e.currentTarget.closest("details")?.removeAttribute("open");
                setIsModalOpen(true);
              }}
              className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm text-ink hover:bg-[#091E420F]"
            >
              <FeatherIcon icon="user" size={16} className="text-ink-subtlest" />
              Mijn profiel
            </button>
            <button
              type="button"
              onClick={logout}
              className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm text-ink hover:bg-[#091E420F]"
            >
              <FeatherIcon icon="log-out" size={16} className="text-ink-subtlest" />
              Uitloggen
            </button>
          </div>
        </details>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default Header;
